export default __webpack_public_path__ + "static/media/locker.28913eb1.svg";